<div *ngIf="displayContent" class="body-content">
    <article>
        <div class="article-content">
            <div class="heading">
                <div [innerHtml]="welcomeMessage ? (welcomeMessage | safeHtml): ''"></div>
            </div>
        </div>

    </article>
    <main>

          <ng-container *ngIf="welcomeSideImage; else defaultSideImage" >
              <img alt="{{welcomeSideImageAlt}}" src="{{welcomeSideImage}}" />
          </ng-container>
          <ng-template #defaultSideImage>
            <img alt="Welcome Side Image" src="assets/images/Layer_1.png" />
          </ng-template>
    </main>
    <article>
        <div class="article-content article-paragraph">

            <div>
                <div [innerHtml]="welcomeParagraphs ? (welcomeParagraphs | safeHtml): ''">
                </div>
                <!-- <p class="article-paragraph">Poverty is an issue that threatens our entire region. In fact, the gap is only widening between those who are doing well and those who are falling behind. It’s an issue that we, as a community, can no longer ignore.</p>
                <p class="article-paragraph"> By taking action and showing your local love, you’ll be helping to fight local poverty, in all its forms—from youth unemployment to homelessness. And that means changing lives, right here at home.
                </p> -->

                <ng-container *ngIf="isUserLoggedIn; else withoutLogin">
                  <uw-button [setInitialFocus]="true" *ngIf="donateButtonLable$ | async as label" [loading]="buttonLoading" [inId]="'uw-donote-now'" [gtmClass]="'uw-donote-now'" (click)="onDonateNow()" [customStyle]="'margin-bottom: 10px; overflow-wrap: break-word; height: unset!important; min-height:63px;'" [tooltipText]="label.tooltipText"  [btnLabel]="label.donateButtonLabel"></uw-button>
                  <ng-container *ngIf="(this.isDonationExist$ | async) as isDonationExist;">
                    <uw-button [loading]="buttonLoading" (click)="onPastDonation()" [customStyle]="'width: fit-content; margin-bottom: 10px;  border: none; border: 2px solid #c3241a; color: #c3241a;
                    background-color: transparent;'" btnLabel="button.view_contribution"></uw-button>
                  </ng-container>
                  <!-- <ng-template #newDeb> -->
                    <ng-container *ngIf="showOptOutOption$ | async; else againOptIn">

                      <button style="margin-top:0.5em;" mat-button id="uw-not-this-year"  [title]="'button.not_this_year' | translate" (click)="onOptOut()">{{'button.not_this_year' | translate}}</button>
                    </ng-container>
                    <ng-template #againOptIn>
                      <!-- <uw-button [loading]="buttonLoading" [btnTypeDefault]="true" (click)="onOptIn()"  btnLabel="{{'button.ready_this_year' | translate}}"></uw-button> -->
                    </ng-template>
                 <!-- </ng-template> -->
                </ng-container>
                <ng-template #withoutLogin>
                  <uw-button *ngIf="donateButtonLable$ | async as label" [loading]="buttonLoading" (click)="onDonateNow()" [customStyle]="'margin-bottom: 10px; overflow-wrap: break-word; height: unset!important; min-height:63px;'" [tooltipText]="label.tooltipText"  [btnLabel]="label.donateButtonLabel"></uw-button>
                </ng-template>

                <uw-button *ngIf="showMyCampaignLink$ | async" (click)="onMyCampaignClick()" [customStyle]="'width: fit-content; margin-bottom: 10px;  border: none; border: 2px solid #c3241a; color: #c3241a;
                background-color: transparent;'" [tooltipText]="myCampaignButtonLabel ?? 'my_campaign.title' | translate"  [btnLabelInnerHtml]="myCampaignButtonLabel ?? 'my_campaign.title' | translate"></uw-button>

            </div>
        </div>
    </article>

    <aside>
        <div *ngIf="link1Content$ | async as link1Content; else sansLink1Content" class="box">
            <div style="cursor: pointer;" [uwRouterLink]="['/donor', campaignGuid,'link1']" [state]="link1Content">
                <img *ngIf="box1Image" alt="{{box1Alt}}" src="{{ box1Image }}" />
               </div>
            <!-- <div class="qty "><span>30M</span></div>
            <div><span class="icon-detail ">Donated Last Year</span></div> -->
        </div>

        <ng-template #sansLink1Content>
          <div class="box">
            <div>
                <img *ngIf="box1Image" alt="{{box1Alt}}" src="{{ box1Image }}" />
            </div>
            <!-- <div class="qty "><span>30M</span></div>
            <div><span class="icon-detail ">Donated Last Year</span></div> -->
          </div>
        </ng-template>
        <div *ngIf="link2Content$ | async as link2Content; else sansLink2Content" class="box">
            <div style="cursor: pointer;" [uwRouterLink]="['/donor', campaignGuid,'link2']" [state]="link2Content">
                <img *ngIf="box2Image" alt="{{box2Alt}}" src="{{ box2Image }}" />
            </div>

        </div>

        <ng-template #sansLink2Content>
          <div class="box">
            <div>
              <img  *ngIf="box2Image" alt="{{box2Alt}}" src="{{ box2Image }}" />
            </div>
            <!-- <div class="qty "><span>30M</span></div>
            <div><span class="icon-detail ">Donated Last Year</span></div> -->
          </div>
        </ng-template>
        <div *ngIf="link3Content$ | async as link3Content; else sansLink3Content" class="box">
            <div style="cursor: pointer;" [uwRouterLink]="['/donor', campaignGuid,'link3']" [state]="link3Content">
                <img *ngIf="box3Image" alt="{{box3Alt}}" src="{{ box3Image }}" />
            </div>
            <!-- <div class="qty "><span>30M</span></div>
            <div><span class="icon-detail ">Donated Last Year</span></div> -->
        </div>

        <ng-template #sansLink3Content>
          <div class="box">
            <div>
              <img *ngIf="box3Image" alt="{{box3Alt}}" src="{{ box3Image }}" />
            </div>
            <!-- <div class="qty "><span>30M</span></div>
            <div><span class="icon-detail ">Donated Last Year</span></div> -->
          </div>
        </ng-template>
        <div *ngIf="link4Content$ | async as link4Content; else sansLink4Content" class="box">
            <div style="cursor: pointer;" [uwRouterLink]="['/donor', campaignGuid,'link4']" [state]="link4Content">
                <img *ngIf="box4Image" alt="{{box4Alt}}" src="{{ box4Image }}" />
            </div>
            <!-- <div class="qty "><span>30M</span></div>
            <div><span class="icon-detail ">Donated Last Year</span></div> -->
        </div>
        <ng-template #sansLink4Content>
          <div class="box">
            <div>
              <img *ngIf="box4Image" alt="{{box4Alt}}" src="{{ box4Image }}" />
            </div>
            <!-- <div class="qty "><span>30M</span></div>
            <div><span class="icon-detail ">Donated Last Year</span></div> -->
          </div>
        </ng-template>
    </aside>

    <div id="aboutUs" class="heading"><span [innerHtml]="aboutUsHeading ? (aboutUsHeading | safeHtml) : ''"></span></div>
    <div id="aboutUsImage">
        <div class="aboutus-image-content">
            <div class="aboutus-red-box d-none d-sm-block"></div>
            <div class="aboutus-image-box">
              <ng-container *ngIf="aboutUsImage; else defaultImage" >
                <!-- <div class="image-box" [innerHtml]="aboutUsImage ? (aboutUsImage | safeHtml): ''"></div> -->
                 <img alt="{{aboutUsImageAlt}}"  src="{{aboutUsImage}}" />

              </ng-container>
              <ng-template #defaultImage>
                <img alt="about Us Image" src="assets/images/Layer_2.png" />
              </ng-template>
              </div>
        </div>
    </div>

    <div id="aboutUsContent">
      <div [innerHtml]="aboutUsParagraph ? (aboutUsParagraph | safeHtml): ''">

      </div>
        <!-- <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean feugiat congue massa, sed dapibus justo consequat eget. Mauris varius justo eget sapien iaculis vulputate. Morbi itae eros quis tellus vehicula cursus ut et est.
        </p>
        <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean feugiat congue massa, sed dapibus justo consequat eget. Mauris varius justo eget sapien iaculis vulputate. Morbi itae eros quis tellus vehicula cursus ut et est.
        </p>
        <p>
            <span class="about-middle-heading ">“Here is a quote that we want to bring out”</span>
        </p>
        <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean feugiat congue massa, sed dapibus justo consequat eget. Mauris varius justo eget sapien iaculis vulputate. Morbi itae eros quis tellus vehicula cursus ut et est.
        </p> -->
        <uw-button *ngIf="donateButtonLable$ | async as label" [loading]="buttonLoading" [inId]="'uw-donote-now-2'" (click)="onDonateNow()" [gtmClass]="'uw-donote-now'" [customStyle]="'margin-bottom: 10px; overflow-wrap: break-word; height: unset!important; min-height:63px;'" [tooltipText]="label.tooltipText"  [btnLabel]="label.donateButtonLabel" ></uw-button>
                <!-- <ng-container *ngIf="showOptOutOption$ | async">
                  <uw-button [loading]="buttonLoading" [btnTypeDefault]="true" (click)="onOptOut()"  btnLabel="{{'Not this year' | translate}}"></uw-button>
                </ng-container> -->
    </div>
</div>
